export default __webpack_public_path__ + "static/media/Blogs2.2c1cdbd8.png";